<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">CNPJ</h6>
                <p>{{(documentoPac?.compradorCnpjCpf  | bnMask: 'CNPJCPF') || '-'}}</p>
            </div>
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Razão Social</h6>
                <p>{{documentoPac?.compradorNome || '-'}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Data de Constituição</h6>
                <p>{{(documentoPac?.compradorDataDeConstituicao | date: 'dd/MM/yyyy') || '-'}}</p>
            </div>
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Natureza da Empresa</h6>
                <p>{{documentoPac?.compradorNaturezaDaEmpresa || '-'}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Caracterização do Capital Social</h6>
                <p>{{documentoPac?.compradorCapitalSocialNome || '-'}}</p>
            </div>
        </div>
        <hr class="hr"/>
        <h5>ROB</h5>
        <div class="row">
            <div class="col-sm-1 col-12">
                <h6 class="mb-0">Tipo</h6>
                <p>{{documentoPac?.compradorRobTipo || '-'}}</p>
            </div>
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Valor (R$)</h6>
                <p>{{(documentoPac?.compradorRobValor || 0) | bnMask: 'MOEDA'}}</p>
            </div>
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Data de Referência</h6>
                <p>{{(documentoPac?.compradorRobData | date: 'dd/MM/yyyy') || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Porte</h6>
                <p>{{documentoPac?.compradorPorteNome || '-'}}</p>
            </div>
        </div>
        <hr class="hr"/>
        <h5>ROB do grupo ao qual pertence</h5>
        <div class="row">
            <div class="col-sm-1 col-12">
                <h6 class="mb-0">Tipo</h6>
                <p>{{documentoPac?.grupoRobTipo || '-'}}</p>
            </div>
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Valor (R$)</h6>
                <p>{{(documentoPac?.grupoRobValor || 0) | bnMask: 'MOEDA'}}</p>
            </div>
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Data de Referência</h6>
                <p>{{(documentoPac?.grupoRobData | date: 'dd/MM/yyyy') || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">CNPJ do Lider do Grupo</h6>
                <p>{{(documentoPac?.grupoCnpjLider | bnMask: 'CNPJCPF') || '-'}}</p>
            </div>
        </div>

        <hr class="hr"/>
        <h5>Endereco sede</h5>
        <div class="row">
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Logradouro</h6>
                <p>{{documentoPac?.compradorEnderecoSede  || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">CEP</h6>
                <p>{{(documentoPac?.compradorCepSede | bnMask: 'CEP') || '-'}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Bairro</h6>
                <p>{{documentoPac?.compradorBairroSede || '-'}}</p>
            </div>
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Município</h6>
                <p>{{documentoPac?.compradorMunicipioSede || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">UF</h6>
                <p>{{documentoPac?.compradorUfSede || '-'}}</p>
            </div>
        </div>

        <hr class="hr"/>
        <h5>Endereco para Correspondência</h5>
        <div class="row">
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Logradouro</h6>
                <p>{{documentoPac?.compradorEnderecoCorrespondencia || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">CEP</h6>
                <p>{{(documentoPac?.compradorCepCorrespondencia | bnMask: 'CEP') || '-'}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Bairro</h6>
                <p>{{documentoPac?.compradorBairroCorrespondencia || '-'}}</p>
            </div>
            <div class="col-sm-2 col-12">
                <h6 class="mb-0">Município</h6>
                <p>{{documentoPac?.compradorMunicipioCorrespondencia || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">UF</h6>
                <p>{{documentoPac?.compradorUfCorrespondencia || '-'}}</p>
            </div>
        </div>
    </div>
</div>
